import { render, staticRenderFns } from "./ImportContacts.vue?vue&type=template&id=ac0649f6&scoped=true"
import script from "./ImportContacts.vue?vue&type=script&lang=js"
export * from "./ImportContacts.vue?vue&type=script&lang=js"
import style0 from "./ImportContacts.vue?vue&type=style&index=0&id=ac0649f6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0649f6",
  null
  
)

export default component.exports